import { DatePicker, Empty, Form, Spin, Table } from "antd";
import React from "react";
import { useState } from "react";
import moment from "moment";
import { ReactComponent as CalendarIcon } from "../../../assets/icons/calendar-icon.svg";
import { getRequest } from "../../../http/axiosConfig/config";
import urls from "../../../http/endpoints/urls";
import { DownloadOutlined } from "@ant-design/icons";
import { generateLedgerPDF } from "./LedgerReport";

export default function Ledger() {
  let customerId = localStorage.getItem("userId");
  let userName = localStorage.getItem("userName");
  const [loading, setLoading] = useState(false);
  const [ledger, setLedger] = useState(null);
  const [showDownload, setShowDownload] = useState(false);
  const [dateForm] = Form.useForm();

  const disabledDate = (current) => {
    return (
      current && current < moment("2026-04-01", "YYYY-MM-DD").startOf("day")
    );
  };


  const getLedgerData = async () => {
  const values = dateForm.getFieldsValue(); 

  try {
    setLoading(true);

    let formattedFormDate = values.fromDate.format("DD-MMM-YY");
    let formattedToDate = values.toDate.format("DD-MMM-YY");

    const res = await getRequest(
      urls.ledgerData(customerId, formattedFormDate, formattedToDate),
    );

    setLedger(res);
    setShowDownload(true);
    setLoading(false);
  } catch (error) {
    setLoading(false);
    console.log(error);
  }
};
  const ledgerColumns = [
    {
      title: (
        <div style={{ fontSize: "10px", whiteSpace: "nowrap" }}>
          Indent Date
        </div>
      ),
      dataIndex: "INDENT_DATE",
      width: 80,
      align: "center",
      render: (text) => (
        <div style={{ fontSize: "10px", whiteSpace: "nowrap" }}>{text}</div>
      ),
    },
    {
      title: (
        <div style={{ fontSize: "10px", whiteSpace: "nowrap" }}>Paid Date</div>
      ),
      dataIndex: "PAID_DATE",
      width: 80,
      align: "center",
      render: (text) => (
        <div style={{ fontSize: "10px", whiteSpace: "nowrap" }}>{text}</div>
      ),
    },
    {
      title: (
        <div style={{ fontSize: "10px", whiteSpace: "nowrap" }}>Route</div>
      ),
      dataIndex: "ROUTE_CODE",
      width: 60,
      align: "center",
      render: (text) => <div style={{ fontSize: "10px" }}>{text}</div>,
    },
    {
      title: (
        <div style={{ fontSize: "10px", whiteSpace: "nowrap" }}>OB</div>
      ),
      dataIndex: "OB",
      width: 60,
      align: "center",
      render: (text) => <div style={{ fontSize: "10px" }}>{text}</div>,
    },
    {
      title: (
        <div style={{ fontSize: "10px", whiteSpace: "nowrap" }}>
          Bill Amount
        </div>
      ),
      dataIndex: "BILL_AMOUNT",
      width: 75,
      align: "center",
      render: (text) => <div style={{ fontSize: "10px" }}>{text}</div>,
    },
    {
      title: (
        <div style={{ fontSize: "10px", whiteSpace: "nowrap" }}>
          Paid Amount
        </div>
      ),
      dataIndex: "PAID_AMT",
      width: 75,
      align: "center",
      render: (text) => <div style={{ fontSize: "10px" }}>{text}</div>,
    },
    {
      title: <div style={{ fontSize: "10px" }}>Balance</div>,
      dataIndex: "BALENCE",
      width: 75,
      align: "center",
      render: (text) => <div style={{ fontSize: "10px" }}>{text}</div>,
    },
  ];

  return (
    <div>
      <div className="page-header">
        Ledger
        {showDownload && ledger && ledger.length > 0 && !loading && (
          <DownloadOutlined
            style={{
              fontSize: 26,
              cursor: "pointer",
              color: "#1890ff",
              marginRight: 15,
            }}
            onClick={() => {
              const fromDate = dateForm
                .getFieldValue("fromDate")
                .format("DD/MM/YY");
              const toDate = dateForm
                .getFieldValue("toDate")
                .format("DD/MM/YY");
              generateLedgerPDF(ledger, fromDate, toDate, { userName });
            }}
            title="Download Ledger PDF"
          />
        )}
      </div>
      <Form
        className="date-range-form"
        form={dateForm}
        layout={"horizontal"}
        onFinish={getLedgerData}
        requiredMark={false}
        onValuesChange={() => setShowDownload(false)}
        style={{
          marginTop: 10,
          marginBottom: 10,
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Form.Item
          noStyle
          name={"fromDate"}
          rules={[{ required: true, message: "Please select from date" }]}
        >
          <DatePicker
            style={{ width: 250 }}
            suffixIcon={<CalendarIcon />}
            format="DD/MM/YY"
            disabledDate={disabledDate}
          />
        </Form.Item>
        <span style={{ margin: "0 4px" }}>To</span>
        <Form.Item
          noStyle
          name={"toDate"}
          rules={[{ required: true, message: "Please select to date" }]}
        >
          <DatePicker
            style={{ width: 250 }}
            suffixIcon={<CalendarIcon />}
            format="DD/MM/YY"
            disabledDate={disabledDate}
          />
        </Form.Item>
        <Form.Item noStyle>
          <button
            style={{
              width: 60,
              padding: 7,
              backgroundColor: "#1890ff",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
              marginLeft: 8,
              boxShadow: "none",
            }}
            onClick={() => dateForm.submit()}
          >
            Go
          </button>
        </Form.Item>
      </Form>

      {!loading && ledger ? (
        <>
          <Table
            dataSource={loading ? [] : ledger}
            locale={{
              emptyText: loading ? <Spin /> : <Empty />,
            }}
            columns={ledgerColumns}
            bordered
            size="small"
            scroll={{ y: "calc(100vh - 420px)", x: 500 }}
            pagination={false}
            summary={(pageData) => {
              let totalBill = 0;
              let totalPaid = 0;
              let totalBalance = 0;

              if (pageData && pageData.length > 0) {
                const formats = ["DD-MMM-YY", "DD-MMM-YYYY", "DD/MM/YYYY", "DD-MM-YYYY", "YYYY-MM-DD"];
                const latestRow = pageData.reduce((latest, current) => {
                  const d1 = moment(latest.INDENT_DATE, formats);
                  const d2 = moment(current.INDENT_DATE, formats);
                  return d2.isBefore(d1) ? latest : current;
                }, pageData[0]);
                totalBalance = Number(latestRow.BALENCE) || 0;
              }

              pageData.forEach(({ BILL_AMOUNT, PAID_AMT }) => {
                totalBill += Number(BILL_AMOUNT) || 0;
                totalPaid += Number(PAID_AMT) || 0;
              });

              return (
                <Table.Summary.Row
                  style={{
                    fontWeight: "bold",
                    fontSize: "10px",
                    textAlign: "center",
                  }}
                >
                  <Table.Summary.Cell index={0} colSpan={4}>
                    Total
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={1}>{totalBill}</Table.Summary.Cell>
                  <Table.Summary.Cell index={2}>{totalPaid}</Table.Summary.Cell>
                  <Table.Summary.Cell index={3}>
                    {totalBalance}
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              );
            }}
          />
          <div style={{ fontWeight: 600, fontSize: 11, marginTop: 10 }}> </div>
        </>
      ) : null}
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin />
        </div>
      ) : null}
    </div>
  );
}
